import { apiUrl } from "../const";
import { doRetryOnTokenExpiration } from "../authSlice";

const doDownloadOPML = (): AppThunk => async (dispatch, getState) => {
  const result = await doRetryOnTokenExpiration({
    method: "get",
    url: `${apiUrl}/opml`,
    responseType: "blob",
  }, dispatch, getState);
  if (result && result.data) {
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "feeds.opml");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default doDownloadOPML;
